export const weekdays = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' }
];

export const DATE_FORMATS = {
  TIME_FORMAT_1: 'time-format-1',
  TIME_FORMAT_2: 'time-format-2',
  DATE_FORMAT_1: 'date-format-1',
  DATE_FORMAT_2: 'date-format-2',
  DATE_FORMAT_3: 'date-format-3',
  DATE_FORMAT_4: 'date-format-4',
  DATE_FORMAT_5: 'date-format-5',
  DATE_FORMAT_6: 'date-format-6'
};

export const DEFAULT_TIME_FORMAT = DATE_FORMATS.TIME_FORMAT_1;
export const DEFAULT_DATE_FORMAT = DATE_FORMATS.DATE_FORMAT_1;

export const languages = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
  { value: 'nl', label: 'Dutch' },
  { value: 'fr', label: 'French' },
  { value: 'es', label: 'Spanish' },
  { value: 'fin', label: 'Finnish' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'swe', label: 'Swedish' }
];

export const timeFormats = [
  // 'hh:mm A'
  { value: DATE_FORMATS.TIME_FORMAT_1, label: '12h (e.g. 9am)' },
  // 'HH:mm'
  { value: DATE_FORMATS.TIME_FORMAT_2, label: '24h (e.g. 17:00)' }
];

export const dateFormats = [
  {
    value: DATE_FORMATS.DATE_FORMAT_1,
    label: '2019-10-29'
  },
  {
    value: DATE_FORMATS.DATE_FORMAT_2,
    label: '2019/10/29'
  },
  {
    value: DATE_FORMATS.DATE_FORMAT_3,
    label: '10-29-2019'
  },
  {
    value: DATE_FORMATS.DATE_FORMAT_4,
    label: '29.10.2019'
  },
  {
    value: DATE_FORMATS.DATE_FORMAT_5,
    label: '29-10-2019'
  },
  {
    value: DATE_FORMATS.DATE_FORMAT_6,
    label: '29/10/2019'
  }
];

// Convert a list to an list with index values as expected by the Wix UI lib
function toWix(list) {
  return list.map((x, i) => ({ value: '' + i, label: x.label }));
}

export const wixWeekdays = toWix(weekdays);
export const wixLanguages = toWix(languages);
export const wixTimeFormats = toWix(timeFormats);
export const wixDateFormats = toWix(dateFormats);



// WEBPACK FOOTER //
// ./src/commons/services/static.js